var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative info-card card shadow-sm border-0 rounded-xl overflow-hidden"},[_c('div',{staticClass:"logo position-absolute h-1 display-4 mb-0 mr-3"},[_vm._t("logo")],2),_c('div',{staticClass:"card-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }